/**
 * Catálogos do inbox: processadores que entregam webhook (enum `Gateways` do payment) e as rotas
 * de ingestão (enum `WebhookEndpoint`).
 *
 * Os valores são os do backend; o rótulo legível vem do i18n — a tela nunca mostra o enum cru.
 */
export const WEBHOOK_INBOX_PROCESSORS = [
  "SANTANDER",
  "BANCO_DO_BRASIL",
  "SICOOB",
  "ITAU",
  "PAGARME",
  "ADYEN",
  "GETNET",
  "CIELO",
  "REDE",
  "PAYPAL",
  "NUPAY",
] as const

export type WebhookInboxProcessor =
  (typeof WEBHOOK_INBOX_PROCESSORS)[number]

export const WEBHOOK_INBOX_ENDPOINTS = [
  "BANKSLIP",
  "PIX",
  "CARD_REFUND",
  "CARD_TOKENIZATION",
  "GENERIC",
] as const
